<template>
  <div class="store-card-main">
    <div class="header">
      <img :src="data.img" />
    </div>
    <div class="body">
      <p class="title">
        {{ data.title || "" }}
      </p>
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          style="width: 50%"
          aria-valuenow="50"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-6">
            <span><img src="/img/box.png" /> Terkumpul</span>
          </div>
          <div class="col-6">
            <span class="value price">Rp. {{ data.now || 0 }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <span><img src="/img/time.png" /> Berakhir</span>
          </div>
          <div class="col-6">
            <span class="value">{{ datevalidate }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <span><img src="/img/time.png" /> Mitra</span>
          </div>
          <div class="col-6">
            <span class="value">{{ data.mitra ? data.mitra.name : "-" }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <span><img src="/img/time.png" /> Lembaga</span>
          </div>
          <div class="col-6">
            <span class="value lembaga">{{ data.lembaga.name || "-" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "card",
  props: {
    data: {
      type: Object,
    },
  },
  mounted() {},
  computed: {
    datevalidate() {
      const date = this.data.valid_date
        ? moment(this.data.valid_date).format("DD MMMM YYYY")
        : "";
      return date;
    },
  },
};
</script>
